<div
  class="demo"
  [nbPopover]="'charts.tooltips.preview' | translate"
  [nbPopoverTrigger]="'hover'"
  [nbPopoverPlacement]="'left'"
>
  <p class="big">{{ "charts.labels.preview" | translate }}</p>
  <p class="small">{{ "charts.labels.previewInfo" | translate }}</p>
</div>
